"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateLogger = void 0;
const LogFactory = require("@sundaysky/logger");
/**
 * Generate a logger (logs data to cloudwatch)
 * @param module module name
 * @param transactionId transaction id (optional) - if passed, all log messages
 * will have this transaction ID prefix
 */
function generateLogger(module, transactionId) {
    if (!transactionId) {
        return LogFactory.logger(module);
    }
    else {
        return LogFactory.logger(module).setTransactionId(transactionId);
    }
}
exports.generateLogger = generateLogger;
//# sourceMappingURL=nodeLogger.js.map